import { DATA_LOADING_STATES } from '@config/Consts';

export const initialState = () => ({
  dataStatus: DATA_LOADING_STATES.NONE,
  isOpen: false,
  conversation: null,
  messages: [],
  transcript: {},
});

export default initialState();
